$(document).ready(function() {
  let $formComposedProducts = $('form#filter-composed-product');

  if ($formComposedProducts.length > 0) {
    let $firstStepButton = $('button#step1'),
        $secondStepButton = $('button#step2'),
        $firstStepBackButton = $('button#step1-back'),
        $secondStepBackButton = $('button#step2-back'),
        processType = '',
        processGender = '',
        processObject = '',
        processAgeDisplay = '',
        processDialId = '';

    $firstStepBackButton.on('click', function (e) {
      e.preventDefault();
      $('#configurator').hide();
      $('#filters').show();
    });

    $secondStepBackButton.on('click', function (e) {
      e.preventDefault();
      destroyStrapSlick();
      $('#configurator_step2').removeClass('active');
      $('#configurator_step1').addClass('active');
      $('#configurator_stepper div').removeClass('active');
      $('#configurator_stepper div:nth-child(1)').addClass('active');
    });

    $formComposedProducts.submit(function(e) {
      e.preventDefault();

      let $submitButton = $('button#step0');

      $submitButton.prop('disabled', true);
      $submitButton.append('<i class="fas fa-spinner fa-spin"></i>');

      $.ajax({
        url: urls.ajax,
        method: 'post',
        data: {
          'action': 'configurator-first-step',
          'data': $(this).serialize()
        }
      }).done( function (response) {
        if (response.error) {
          $submitButton.prop('disabled', false);
          $submitButton.find('i').remove();
          $('p.error-message').html(response.message);
        } else {
          $submitButton.prop('disabled', false);
          $submitButton.find('i').remove();
          $('#filters').hide();
          $('#configurator').show();
          $('#step_1-title').html(response.title);
          $('#step_1-description').html(response.description);
          $('#step_1-results').html(response.products);
          processType = response.type;
          processGender = response.gender;
          processAgeDisplay = response.age_display;

          if (response.age < 6) {
            $('#step_1-results .col_demi:nth-child(2)').find('input').click();
          }

        }
      });
    });

    $firstStepButton.on('click', function (e) {
      e.preventDefault();

      $firstStepButton.prop('disabled', true);
      $firstStepButton.append('<i class="fas fa-spinner fa-spin"></i>');

      processDialId = $('#configurator_step1').find('input[name="object_type"]:checked').val();

      $.ajax({
        url: urls.ajax,
        method: 'post',
        data: {
          'action': 'configurator-second-step',
          'type': processType,
          'product_id': processDialId,
          'gender': processGender,
          'age_display': processAgeDisplay
        }
      }).done( function (response) {
        if (response.error) {
          $firstStepButton.prop('disabled', false);
          $firstStepButton.find('i').remove();
        } else {
          if (response.product_url) {
            window.location = response.product_url;
          } else {
            $firstStepButton.prop('disabled', false);
            $firstStepButton.find('i').remove();
            $('#configurator_step1').removeClass('active');
            $('#configurator_step2').addClass('active');
            $('#configurator_stepper div').removeClass('active');
            $('#configurator_stepper div:nth-child(2)').addClass('active');
            $('#step_2-title').html(response.title);
            $('#step_2-description').html(response.description);
            $('#step_2-results').html(response.products);

            initStrapSlick();

            processObject = $(".slider_strap .slide:first").data('product_id');
          }
        }
      });
    });

    function initStrapSlick() {
      $(".slider_strap").slick({
        lazyLoad: "progressive",
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 800,
        pauseOnHover: true,
        infinite: true,
        arrows: true,
        appendArrows: $('.slider_nav'),
        dots: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        focusOnSelect: true,
        centerMode: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
    function destroyStrapSlick() {
      $(".slider_strap").slick('unslick');
    }

    $(".slider_strap .slide").on('click', function() {
      processObject = $(this).data('product_id');
    });

    $(".slider_strap").on('afterChange', function(event, slick, currentSlide){
      processObject = $(slick.$slides.get(currentSlide)).find('.slide').data('product_id');
    });

    $secondStepButton.on('click', function(e) {
      e.preventDefault();

      $secondStepButton.prop('disabled', true);
      $secondStepButton.append('<i class="fas fa-spinner fa-spin"></i>');

      $.ajax({
        url: urls.ajax,
        method: 'post',
        data: {
          'action': 'configurator-last-step',
          'first_composed_product': processDialId,
          'second_composed_product': processObject,
          'gender': processGender
        }
      }).done( function (response) {
        $secondStepButton.prop('disabled', false);
        $secondStepButton.find('i').remove();

        if (response.product_url) {
          window.location = response.product_url;
        }
      });
    });
  }
});
